"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _omit = _interopRequireDefault(require("../utils/underscore/omit"));

var _UIModalDialog = _interopRequireDefault(require("./UIModalDialog"));

var _decorators = require("../utils/propTypes/decorators");

var PanelContext = _interopRequireWildcard(require("../context/PanelContext"));

var _ModalPanelTransition = _interopRequireDefault(require("./internal/ModalPanelTransition"));

var _AbstractModal = _interopRequireDefault(require("./internal/AbstractModal"));

var _Functions = require("../core/Functions");

var _BrowserTest = require("../utils/BrowserTest");

var inPanelContext = {
  inPanel: true
};

var UIModalPanel =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(UIModalPanel, _PureComponent);

  function UIModalPanel(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UIModalPanel);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UIModalPanel).call(this, props));
    _this.handleOpenStart = _this.handleOpenStart.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleOpenComplete = _this.handleOpenComplete.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(UIModalPanel, [{
    key: "handleOpenStart",
    value: function handleOpenStart() {
      var onOpenStart = this.props.onOpenStart;
      (0, _Functions.callIfPossible)(onOpenStart); // Safari glitches the transition if an element in the modal panel is focused (#6033)

      if ((0, _BrowserTest.isSafari)()) {
        this._autoFocusedEl = document.activeElement;

        this._autoFocusedEl.blur();
      }
    }
  }, {
    key: "handleOpenComplete",
    value: function handleOpenComplete() {
      var onOpenComplete = this.props.onOpenComplete;
      (0, _Functions.callIfPossible)(onOpenComplete);

      if ((0, _BrowserTest.isSafari)()) {
        this._autoFocusedEl.focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          __panelKey = _this$props.panelKey,
          width = _this$props.width,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["panelKey", "width"]);
      return _react.default.createElement(PanelContext.Provider, {
        value: inPanelContext
      }, _react.default.createElement(_AbstractModal.default, (0, _extends2.default)({}, rest, {
        _use: "sidebar",
        _dialogWidth: width,
        componentName: "UIModalPanel",
        Transition: _ModalPanelTransition.default,
        onOpenStart: this.handleOpenStart,
        onOpenComplete: this.handleOpenComplete
      })));
    }
  }]);
  return UIModalPanel;
}(_react.PureComponent);

UIModalPanel.propTypes = (0, _extends2.default)({}, (0, _omit.default)(_UIModalDialog.default.propTypes, ['centered', 'size', 'use']), {
  onCloseComplete: _react.PropTypes.func,
  onCloseStart: _react.PropTypes.func,
  onOpenComplete: _react.PropTypes.func,
  onOpenStart: _react.PropTypes.func,
  panelKey: (0, _decorators.hidden)(_react.PropTypes.string),
  _contextual: _react.PropTypes.bool
});
UIModalPanel.defaultProps = {
  width: 700,
  _contextual: false
};
UIModalPanel.displayName = 'UIModalPanel';
var _default = UIModalPanel;
exports.default = _default;
module.exports = exports.default;